// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bel_a bhs_rj bhs_rk bhs_vh bhs_eb bhs_vf bhs_gu bhs_kh"};